app.controller('purchaseReasonCodeMasterCtrl', function ($scope, urlServices, toaster, modalService) {
    var api = 'api/purchase-reason-codes';

    $scope.purchaseReasonCodeRows = [];
    $scope.purchaseReasonCodeLoading = false;
    $scope.purchaseReasonCodeSaving = false;
    $scope.purchaseReasonCodeFilter = '';

    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    function normalizeError(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage || 'Error tidak terdeteksi';
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }
        return String(err);
    }

    function resetPurchaseReasonCodeForm() {
        $scope.purchaseReasonCodeForm = {
            id: 0,
            reasonCode: '',
            reasonName: '',
            sortOrder: 0,
            isActive: true
        };
    }

    $scope.loadPurchaseReasonCodes = function () {
        $scope.purchaseReasonCodeLoading = true;
        return urlServices.ambilData(api + '?include_inactive=1', {}, function (err, result) {
            $scope.purchaseReasonCodeLoading = false;
            if (err) {
                return toaster.pop('error', 'Master Purchase', normalizeError(err, 'Gagal memuat reason code purchase'));
            }

            $scope.purchaseReasonCodeRows = (result || []).filter(function (item) {
                return item && item.reasonCode;
            });
        });
    };

    $scope.editPurchaseReasonCode = function (row) {
        $scope.purchaseReasonCodeForm = {
            id: row.id || 0,
            reasonCode: row.reasonCode || '',
            reasonName: row.reasonName || '',
            sortOrder: row.sortOrder || 0,
            isActive: row.isActive !== false
        };
    };

    $scope.cancelPurchaseReasonCode = function () {
        resetPurchaseReasonCodeForm();
    };

    $scope.savePurchaseReasonCode = function () {
        var payload = {
            id: $scope.purchaseReasonCodeForm.id || 0,
            reasonCode: normalizeTextValue($scope.purchaseReasonCodeForm.reasonCode).toUpperCase(),
            reasonName: normalizeTextValue($scope.purchaseReasonCodeForm.reasonName),
            sortOrder: $scope.purchaseReasonCodeForm.sortOrder || 0,
            isActive: $scope.purchaseReasonCodeForm.isActive ? 1 : 0
        };
        var requestMethod = payload.id ? urlServices.updateData : urlServices.simpanData;

        if (!payload.reasonCode) {
            return toaster.pop('warning', 'Master Purchase', 'Reason code wajib diisi');
        }
        if (!payload.reasonName) {
            return toaster.pop('warning', 'Master Purchase', 'Nama reason wajib diisi');
        }

        $scope.purchaseReasonCodeSaving = true;
        return requestMethod(api, payload, function (err, result) {
            $scope.purchaseReasonCodeSaving = false;
            if (err) {
                return toaster.pop('error', 'Master Purchase', normalizeError(err, 'Gagal menyimpan reason code purchase'));
            }

            $scope.purchaseReasonCodeRows = result && result.items ? result.items : $scope.purchaseReasonCodeRows;
            resetPurchaseReasonCodeForm();
            toaster.pop('success', 'Master Purchase', 'Reason code purchase berhasil disimpan');
            if (!(result && result.items)) {
                $scope.loadPurchaseReasonCodes();
            }
        });
    };

    $scope.deletePurchaseReasonCode = function (row) {
        modalService.showModal({}, {
            closeButtonText: 'Batal',
            actionButtonText: 'Hapus',
            headerText: 'Hapus Reason Code',
            bodyText: 'Hapus reason code ' + (row.reasonCode || '-') + '?'
        }).then(function (confirmed) {
            if (!confirmed) {
                return;
            }

            return urlServices.hapusData(api + '/' + encodeURIComponent(row.id), {}, function (err) {
                if (err) {
                    return toaster.pop('error', 'Master Purchase', normalizeError(err, 'Gagal menghapus reason code purchase'));
                }
                if (Number($scope.purchaseReasonCodeForm.id || 0) === Number(row.id || 0)) {
                    resetPurchaseReasonCodeForm();
                }
                toaster.pop('success', 'Master Purchase', 'Reason code purchase berhasil dihapus');
                $scope.loadPurchaseReasonCodes();
            });
        });
    };

    resetPurchaseReasonCodeForm();
    $scope.loadPurchaseReasonCodes();
});